export const CLEAR_STATE = 'CLEAR_STATE';

export const REQUEST_CANCELED = 'REQUEST_CANCELED';
export const CANCEL_REQUEST = 'CANCEL_REQUEST';



// WEBPACK FOOTER //
// ./src/state/types.js